var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('form-wizard', {
    staticClass: "vertical-steps steps-transparent mb-3",
    attrs: {
      "color": "#7367F0",
      "title": null,
      "subtitle": null,
      "layout": "vertical",
      "finish-button-text": "Submit",
      "back-button-text": "Previous"
    },
    on: {
      "on-complete": _vm.formSubmitted
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Account Details",
      "icon": "feather icon-file-text"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Account Details ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Enter Your Account Details. ")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Username",
      "label-for": "vi-username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-username",
      "placeholder": "johndoe"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "vi-email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-email",
      "type": "email",
      "placeholder": "john.doe@email.com"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Password",
      "label-for": "vi-password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-password",
      "type": "password",
      "placeholder": "Password"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Confirm Password",
      "label-for": "vi-c-password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-c-password",
      "type": "password",
      "placeholder": "Re-type Password"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Personal Info",
      "icon": "feather icon-user"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Personal Info ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Personal Info.")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "First Name",
      "label-for": "vi-first-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-first-name",
      "placeholder": "John"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Last Name",
      "label-for": "vi-last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-last-name",
      "placeholder": "Doe"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Country",
      "label-for": "vi-country"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "vi-country",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.countryName,
      "selectable": function selectable(option) {
        return !option.value.includes('select_value');
      },
      "label": "text"
    },
    model: {
      value: _vm.selectedContry,
      callback: function callback($$v) {
        _vm.selectedContry = $$v;
      },
      expression: "selectedContry"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Language",
      "label-for": "vi-language"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "vi-language",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "selectable": function selectable(option) {
        return !option.value.includes('select_value');
      },
      "options": _vm.languageName,
      "label": "text"
    },
    model: {
      value: _vm.selectedLanguage,
      callback: function callback($$v) {
        _vm.selectedLanguage = $$v;
      },
      expression: "selectedLanguage"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Address",
      "icon": "feather icon-map-pin"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Address ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Address.")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Address",
      "label-for": "vi-address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-address",
      "placeholder": "98 Borough bridge Road, Birmingham"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Landmark",
      "label-for": "vi-landmark"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-landmark",
      "placeholder": "Borough bridge"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pincode",
      "label-for": "vi-pincode"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-pincode",
      "placeholder": "658921"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "City",
      "label-for": "vi-city"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-city",
      "placeholder": "Birmingham"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Social Links",
      "icon": "feather icon-link"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Social Links ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Social Links")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Twitter",
      "label-for": "vi-twitter"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-twitter",
      "placeholder": "https://twitter.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Facebook",
      "label-for": "vi-facebook"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-facebook",
      "placeholder": "https://facebook.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Google+",
      "label-for": "vi-google-plus"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-google-plus",
      "placeholder": "https://plus.google.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "LinkedIn",
      "label-for": "vi-linked-in"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vi-linked-in",
      "placeholder": "https://linkedin.com/abc"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }